var actionMenuTemplate, actionsTemplate, capitalize, modifierTemplate, render, setPayout, setupEvents, sprintf, submitAction, submitModifier, ui, updateDetails, util, voidModifier, voidableModifierTemplate, voidedModifierTemplate,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

if (global.jQuery == null) {
  global.jQuery = require('jquery');
}

require('bootstrap/js/tooltip');

require('bootstrap/js/dropdown');

require('bootstrap/js/modal');

util = require('evesrp/util');

ui = require('evesrp/common-ui');

capitalize = require('underscore.string/capitalize');

sprintf = (require('sprintf-js')).sprintf;

actionMenuTemplate = require('evesrp/templates/action_menu');

actionsTemplate = require('evesrp/templates/actions');

voidedModifierTemplate = require('evesrp/templates/voided_modifier');

voidableModifierTemplate = require('evesrp/templates/voidable_modifier');

modifierTemplate = require('evesrp/templates/modifier');

render = function(request) {
  var $actionMenu, $actions, $element, $evaluatingOnly, $payout, $statusBadge, attr, bothPromise, formatPromise, link, ref, results, text, translationPromise;
  translationPromise = ui.setupTranslations();
  formatPromise = ui.setupFormats();
  bothPromise = jQuery.when(translationPromise, formatPromise);
  $actionMenu = jQuery('#actionMenu');
  translationPromise.done(function() {
    $actionMenu.empty();
    return $actionMenu.append(actionMenuTemplate(request));
  });
  $actions = jQuery('#actionList');
  bothPromise.done(function() {
    $actions.empty();
    return $actions.append(actionsTemplate(request));
  });
  $statusBadge = jQuery('#request-status');
  translationPromise.done(function() {
    $statusBadge.removeClass('label-warning label-info label-success label-danger');
    $statusBadge.addClass("label-" + (util.statusColor(request.status)));
    return $statusBadge.text(ui.i18n.gettext(capitalize(request.status)));
  });
  if (request.modifiers.length !== 0) {
    bothPromise.done(function() {
      var $modifierList, modifier, modifiers;
      modifiers = (function() {
        var i, len, ref, results;
        ref = request.modifiers;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          modifier = ref[i];
          if (modifier["void"]) {
            results.push(voidedModifierTemplate(modifier));
          } else if (request.status === 'evaluating' && indexOf.call(request.valid_actions, 'approved') >= 0) {
            results.push(voidableModifierTemplate(modifier));
          } else {
            results.push(modifierTemplate(modifier));
          }
        }
        return results;
      })();
      $modifierList = jQuery('#modifierList');
      $modifierList.empty();
      return $modifierList.append(modifiers);
    });
  }
  (jQuery('#request-details')).html(util.urlize(request.details, 30));
  (jQuery('#request-division')).text(request.division.name);
  $payout = jQuery('#request-payout');
  bothPromise.done(function() {
    var basePayout, translated;
    translated = ui.i18n.gettext("Base Payout: %(base_payout)s");
    basePayout = ui.currencyFormat(parseFloat(request.base_payout));
    $payout.prop('title', sprintf(translated, {
      base_payout: basePayout
    }));
    return $payout.text(ui.currencyFormat(parseFloat(request.payout)));
  });
  $evaluatingOnly = jQuery('.evaluating-only');
  $evaluatingOnly.prop('disabled', request.status !== 'evaluating');
  if (request.transformed != null) {
    ref = request.transformed;
    results = [];
    for (attr in ref) {
      link = ref[attr];
      $element = jQuery("#" + attr);
      text = request[attr];
      if (attr === 'status') {
        $element = $statusBadge;
      } else if (attr === 'pilot') {
        text = request.pilot.name;
      }
      results.push($element.html("<a href=\"" + link + "\" target=\"_blank\">" + text + "<i class\"fa fa-external-link\"></i></a>"));
    }
    return results;
  }
};

submitAction = function(ev) {
  var $form, $target;
  $target = jQuery(ev.target);
  $form = $target.closest('form');
  if (($target.prop('nodeName')) !== 'A' && $target.hasClass('dropdown-toggle')) {
    return true;
  }
  ($form.find("input[name='type_']")).val($target.attr('id'));
  jQuery.ajax({
    type: 'POST',
    url: window.location.pathname,
    data: $form.serialize(),
    success: function(data) {
      ($form.find('textarea')).val('');
      if (!$target.hasClass('btn')) {
        return ($form.find('button.dropdown-toggle')).dropdown('toggle');
      }
    },
    complete: function(jqxhr) {
      return render(jqxhr.responseJSON);
    }
  });
  return false;
};

submitModifier = function() {
  var $form, $this;
  $this = jQuery(this);
  $form = $this.closest('form');
  ($form.find("input[name='type_']")).val($this.attr('id'));
  ($form.find('button.dropdown-toggle')).dropdown('toggle');
  jQuery.ajax({
    type: 'POST',
    url: window.location.pathname,
    data: $form.serialize(),
    success: function(data) {
      ($form.find('textarea')).val('');
      return ($form.find('input#value')).val('');
    },
    complete: function(jqxhr) {
      return render(jqxhr.responseJSON);
    }
  });
  return false;
};

voidModifier = function(ev) {
  var $form;
  $form = jQuery(ev.target);
  jQuery.ajax({
    type: 'POST',
    url: window.location.pathname,
    data: $form.serialize(),
    complete: function(jqxhr) {
      return render(jqxhr.responseJSON);
    }
  });
  return false;
};

setPayout = function(ev) {
  var $form;
  $form = jQuery(this);
  jQuery.ajax({
    type: 'POST',
    url: window.location.pathname,
    data: $form.serialize(),
    success: function(data) {
      return ($form.find('input#value')).val('');
    },
    complete: function(jqxhr) {
      return render(jqxhr.responseJSON);
    }
  });
  return false;
};

updateDetails = function(ev) {
  var $form;
  $form = jQuery(ev.target);
  jQuery.ajax({
    type: 'POST',
    url: window.location.pathname,
    data: $form.serialize(),
    complete: function(jqxhr) {
      return render(jqxhr.responseJSON);
    }
  });
  (jQuery('#detailsModal')).modal('hide');
  return false;
};

setupEvents = function() {
  var $payoutElement;
  (jQuery('#actionMenu')).on('click', submitAction);
  (jQuery('ul#request-modifier-type li a')).on('click', submitModifier);
  (jQuery('#modifierList')).on('submit', voidModifier);
  (jQuery('form#payoutForm')).on('submit', setPayout);
  (jQuery('#detailsModal form')).on('submit', updateDetails);
  $payoutElement = jQuery('#requests-payout');
  return (jQuery('.row')).tooltip({
    selector: '#request-payout',
    placement: 'right'
  });
};

exports.setupEvents = setupEvents;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
